import { Clock3, Phone } from "lucide-react";
import Logo from "./Logo";
import { HOURS, PHONE_TEL } from "../data/site";
import { trackEvent } from "../lib/track";

export default function AppHeader() {
  return (
    <header className="app-header" data-testid="app-header">
      <div className="app-header-inner">
        <Logo />
        <span className="header-hours" data-testid="header-hours">
          <Clock3 size={14} /> Her Gün {HOURS}
        </span>
        <span className="header-tag" data-testid="header-tag">Online Randevu</span>
        <a
          className="header-call"
          href={`tel:${PHONE_TEL}`}
          onClick={() => trackEvent("phone_click", { location: "header" })}
          aria-label="Lunessa Spa Masaj'ı telefonla ara"
          data-testid="header-call-button"
        >
          <Phone size={19} />
        </a>
      </div>
    </header>
  );
}
